import { Button } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { CompetitionRegistrationPageController } from "../controllers/CompetitionRegistrationPageController";

interface Props {
  competitionName: string;
}

const EmailValidationMessage = ({ competitionName }: Props) => {
  const controller = CompetitionRegistrationPageController.use();
  const { resendingValidationEmail, validationEmailLink } = controller.state;

  return (
    <div className="rounded-lg leading-6 bg-green-50 border-green-600 shadow-md border p-6 ">
      <h2 className="text-xl font-semibold">Check your email</h2>
      <p className="mt-2">
        We've sent you an email with a link to verify your account and complete your registration for{" "}
        {competitionName}.
      </p>
      <p className="mt-4">
        Please check your inbox and <strong className="font-semibold">click the verification link</strong> to
        continue. If you don't see the email, check your spam folder.
      </p>
      {validationEmailLink && (
        <p className="mt-4 text-sm">
          Local/dev shortcut:{" "}
          <a href={validationEmailLink} className="font-semibold underline">
            click here to verify
          </a>
          .
        </p>
      )}
      <p className="mt-4 text-sm">
        Didn't receive the email?{" "}
        <Button
          type="button"
          kind="link"
          compact
          className="!inline p-0 align-baseline"
          disabled={resendingValidationEmail}
          onClick={() => controller.actionResendValidationEmail()}
        >
          {resendingValidationEmail ? "Sending..." : "Resend"}
        </Button>
      </p>
    </div>
  );
};

export default ApplicationView(EmailValidationMessage);
